export default "__VITE_ASSET__DfGqGTBd__"